import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";
import { useTranslation } from "react-i18next";

import "./style.scss";

export const getZMTZiplockRate = (coinInterestRates) => {
  const { nodes } = coinInterestRates;
  return nodes.find((x) => x.acfCoinInterestRates.cirCoinCode === "ZMT")
    ?.acfCoinInterestRates.cirZiplockRate;
};

export const getCriteriaHeading = (title, label, lockApy) => ({
  title: <>{title}</>,
  vip: [{ name: <>-</> }],
  vip1: [
    {
      name: (
        <>
          {label}
          <br />
          100 ZMT
          <br />
          {lockApy}
        </>
      ),
    },
  ],
  vip2: [
    {
      name: (
        <>
          {label}
          <br />
          1,000 ZMT
          <br />
          {lockApy}
        </>
      ),
    },
  ],
  vip3: [
    {
      name: (
        <>
          {label}
          <br />
          5,000 ZMT
          <br />
          {lockApy}
        </>
      ),
    },
  ],
  vip4: [
    {
      name: (
        <>
          {label}
          <br />
          20,000 ZMT
          <br />
          {lockApy}
        </>
      ),
    },
  ],
  classNames: "bg sub-heading",
  skipTrending: true,
});

const MemberBenefitTable = ({
  className,
  tableTitle,
  benefits,
  footer = null,
  hasAdditionalHeader = false,
}) => {
  const { t } = useTranslation();

  const Benefit = ({ level, isTrending = false }) => (
    <ul>
      {level.map(({ name, comingSoon = null }, i) =>
        name === "-" ? (
          <div className="text-center" key={`member-benefit-row-item-${i}`}>
            {name}
          </div>
        ) : (
          <React.Fragment key={`member-benefit-row-item-${i}`}>
            <li className={cx({ trending: isTrending })}>{name}</li>
            {comingSoon && <span className="coming-soon">{comingSoon}</span>}
          </React.Fragment>
        )
      )}
    </ul>
  );

  const AdditionalHeader = () =>
    hasAdditionalHeader && (
      <div className="additional-heading">
        <div className="additional-heading__benefits">
          <span>{t("earn.availableAssets.benefits")}</span>
        </div>
        <div className="additional-heading__zipcrew">
          <span>ZipCrew</span>
        </div>
      </div>
    );

  return (
    <div id="member-benefit-table" className={className}>
      <AdditionalHeader />
      <div className="benefit-table table-grid">
        <div className="heading benefit-heading">
          <span>{tableTitle}</span>
        </div>
        <div className="heading bg vip vip-heading">
          <span>VIP</span>
        </div>
        <div className="heading bg vip1 vip1-heading">
          <span>VIP 1</span>
        </div>
        <div className="heading bg vip2 vip2-heading">
          <span>VIP 2</span>
        </div>
        <div className="heading bg vip3 vip3-heading">
          <span>VIP 3</span>
        </div>
        <div className="heading bg vip4 vip4-heading">
          <span>VIP 4</span>
        </div>

        {benefits.map(
          (
            { title, vip, vip1, vip2, vip3, vip4, classNames, skipTrending },
            i
          ) => (
            <React.Fragment key={`member-benefit-row-${i}`}>
              <div className={cx("grid-row benefit p-3", classNames)}>
                {title}
              </div>
              <div className={cx("grid-row content vip py-3 px-1", classNames)}>
                <Benefit level={vip} />
              </div>
              <div
                className={cx("grid-row content vip1 py-3 px-1", classNames)}
              >
                <Benefit level={vip1} />
              </div>
              <div
                className={cx("grid-row content vip2 py-3 px-1", classNames)}
              >
                <Benefit level={vip2} />
              </div>
              <div
                className={cx("grid-row content vip3 py-3 px-1", classNames)}
              >
                <Benefit level={vip3} />
              </div>
              <div
                className={cx("grid-row content vip4 py-3 px-1", classNames)}
              >
                <Benefit level={vip4} isTrending={!skipTrending} />
              </div>
            </React.Fragment>
          )
        )}
      </div>
      {footer && (
        <div className="d-flex flex-column flex-lg-row">
          <div
            className={cx(
              "footer__table-link align-self-center text-center text-lg-left px-0 py-3",
              { "d-none d-lg-block": !footer.link }
            )}
          >
            {footer.link}
          </div>

          <div className="footer__table-btn py-3">{footer.button}</div>
        </div>
      )}
    </div>
  );
};

const BenefitDetailType = PropTypes.shape({
  name: PropTypes.node.isRequired,
  comingSoon: PropTypes.any,
}).isRequired;

MemberBenefitTable.propTypes = {
  tableTitle: PropTypes.any,
  benefits: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.any,
      vip: PropTypes.arrayOf(BenefitDetailType),
      vip1: PropTypes.arrayOf(BenefitDetailType),
      vip2: PropTypes.arrayOf(BenefitDetailType),
      vip3: PropTypes.arrayOf(BenefitDetailType),
      vip4: PropTypes.arrayOf(BenefitDetailType),
      classNames: PropTypes.string,
    })
  ).isRequired,
  footer: PropTypes.shape({
    link: PropTypes.any,
    button: PropTypes.any,
  }),
};

export default MemberBenefitTable;
